import { makeId, getImg } from "./../../utils";
import {
  stamp_0,
  stamp_1,
  stamp_2,
  stampBig_0,
  stampBig_1,
  stampBig_2,
  stampBig_3,
  stampBig_4,
  stampBig_5,
} from "./pngs";
import "./CoalitionStampsProgress.scss";

export const CoalitionStampsProgress = ({
  used = 0,
  needed = 0,
  drawables = 5,
}) => {
  const draw = [];
  const limit = needed >= drawables ? drawables : needed;
  for (let i = 0; i < limit; i++) {
    const source = used >= needed ? stamp_2 : i < used ? stamp_1 : stamp_0;
    draw.push(
      <span key={makeId(5)} className="bullet">
        <img src={source} alt="stamp" />
      </span>
    );
  }
  const remanent = needed - drawables;
  if (remanent <= 0) return draw;
  draw.push(
    <span key={makeId(5)} className="bullet">
      <label className="simple-counter">{`+${remanent}`}</label>
    </span>
  );
  return draw;
};

export const CoalitionStampsProgressDetail = ({
  used = 0,
  needed = 0,
  drawables = 5,
}) => {
  const draw = [];
  const limit = needed >= drawables ? drawables : needed;
  let counter = 0;
  let filled = 0;
  let remanent = 0;

  const fillBullets = (limit, src) => {
    for (let i = 0; i < limit; i++) {
      draw.push(
        <span key={makeId(5)} className="bullet">
          {getImg(src, "stamp")}
        </span>
      );
    }
  };

  if (used >= needed) {
    counter = needed - limit;
    remanent = 0;
    filled = limit;
  } else if (used === 0) {
    counter = needed - limit;
    remanent = limit;
    filled = 0;
  } else {
    counter = needed - limit;
    const helper = needed - used;
    remanent = helper >= limit ? limit : helper;
    filled = limit - remanent;
  }

  if (counter) {
    const src =
      used === 0 ? stampBig_3 : used < needed ? stampBig_4 : stampBig_5;
    draw.push(
      <span
        key={makeId(5)}
        className="bullet-counter"
        style={{ backgroundImage: `url(${src})` }}
      >
        <label>{`+${counter}`}</label>
      </span>
    );
  }
  fillBullets(filled, used < needed ? stampBig_1 : stampBig_2);
  fillBullets(remanent, stampBig_0);
  return draw;
};
